import React from 'react';
import classnames from 'classnames';
import { arrayMove, SortableElement as sortableElement, SortableHandle as sortableHandle, SortableContainer as sortableContainer } from 'react-sortable-hoc';
import Card from '../../card/Card';
import Icon from '../../icon/Icon';
import DragChunkySvg from '../../iconography/icons/DragChunky';
var SortableHandle = sortableHandle(function (_ref) {
  var children = _ref.children;
  var content = children;

  if (!content) {
    content = React.createElement(Icon, {
      type: React.createElement(DragChunkySvg, null),
      size: "small",
      color: "grey-300"
    });
  }

  return React.createElement("span", {
    className: "eds-l-pad-left-4 eds-l-lg-pad-left-6 eds-card-list__handle"
  }, content);
});
export var SortableItem = sortableElement(function (_ref2) {
  var dragHandle = _ref2.dragHandle,
      content = _ref2.content,
      style = _ref2.style,
      isSelected = _ref2.isSelected;
  var listItemClassNames = classnames('eds-card-list__sortable', {
    'eds-card-list__sortable--draggable': dragHandle === null
  });
  var cardContentClassNames = classnames('eds-align--center-vertical eds-card-list__sortable-content', {
    'eds-card-list__sortable--hoverable': !isSelected
  });
  return React.createElement("li", {
    className: listItemClassNames,
    "data-spec": "eds-card-list-sortable"
  }, React.createElement(Card, {
    style: style,
    isSelected: isSelected
  }, React.createElement("div", {
    className: cardContentClassNames
  }, dragHandle !== null && React.createElement(SortableHandle, null, dragHandle), content)));
});
export var SortableList = sortableContainer(function (_ref3) {
  var items = _ref3.items;
  return React.createElement("ul", {
    className: "eds-card-list"
  }, items);
});
export { arrayMove };